import { Box, Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from '../../store/menuSlice'
import { useNavigate } from 'react-router-dom'
import HealthBehavior from '../../assets/images/assessment/HealthBehavior.jpg'
import MentalHealth from '../../assets/images/assessment/MentalHealth.jpg'
import styles from './healthAss.module.css'
import ModalExportHealthAssessment from 'components/modal/ModalExportHealthAssessment'
import { useSelector } from 'react-redux'
import Loader from '../../components/Loader';
import * as api from '../services/api'


function Assessment() {
    const auth = useSelector((state) => state.auth.user_data)
    const [permission, setPermission] = useState('')
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [search, setSearch] = useState('')
    const [courseAll, setCourseAll] = useState([])
    const [courseList, setCourseList] = useState([])
    const [openModalExport, setOpenModalExport] = useState(false)

    useEffect(() => {
        // dispatch(menuActive('แบบประเมินสุขภาพ'))
        dispatch(menuActive('แบบประเมินทั้งหมด'))
        fetchFormEvaluation();
        let perm = auth.permission.group_code
        setPermission(perm)
        // console.log(perm)
    }, [])

    const fetchFormEvaluation = async (searchQuery) => {
        setLoading(true);
        const res = await api.findFormEvaluation(searchQuery, 'Active');
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setCourseAll(detail);
                setCourseList(detail);
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const handleClickOpen = (e) => {
        // console.log(e.evaluation_code)
        if (e.evaluation_code === 'EVA-F-0001') {
            navigate('/mentalHealthAssessment')
        } else if (e.evaluation_code === 'EVA-F-0002') {
            navigate('/healthBehaviorSurvey')
        } else {
            navigate('/assessmentDetail/', { state: { evaluation_code: e.evaluation_code, button: 1 } });
        }
        // console.log(e.evaluation_code)
        //navigate(e.path)
    }

    const handleClickSearch = () => {
        if (search === '') {
            setCourseList(courseAll)
        } else {
            const filteredItems = courseAll.filter((item) =>
                item.title.toLowerCase().includes(search.toLowerCase())
            )
            setCourseList(filteredItems)
        }
    }

    const handleClickExport = () => {
        setOpenModalExport(true)
    }

    return (
        <>
            <Loader loading={loading} />
            {openModalExport ?
                <ModalExportHealthAssessment
                    onClose={() => { setOpenModalExport(false) }}
                />
                : null
            }
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>แบบประเมินทั้งหมด</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    display: 'flex',
                    padding: '5px'
                }}>
                    <TextField
                        fullWidth
                        variant="standard"
                        sx={{
                            ...InputCSS
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                        value={search}
                        onChange={(e) => { setSearch(e.target.value) }}
                    />
                    <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                </Box>

                {permission !== 'G-0030' &&
                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                        <Button
                            variant='outlined'
                            sx={{ backgroundColor: '#C6E8E8', border: 'none' }}
                            onClick={() => {
                                handleClickExport()
                            }}
                        >Export</Button>
                    </Box>
                }

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridGap: '10px',
                    "@media (max-width: 1000px)": {
                        gridTemplateColumns: '1fr 1fr',
                    },
                    "@media (max-width: 600px)": {
                        gridTemplateColumns: '1fr',
                    }
                }}>
                    {courseList.map((item, index) => (
                        <Box sx={{
                            border: '1px solid #2F327D1A',
                            boxShadow: '2px 2px 10px #2F327D1A',
                            backgroundColor: '#ffffff',
                            borderRadius: '10px',
                            padding: '10px',
                            cursor: 'pointer'
                        }}
                            key={index}
                            onClick={() => {
                                // if (item['title'] === 'แบบประเมินสุขภาพใจ') {
                                //     alert('แบบสอบถามนี้ยังไม่เปิดรับคำตอบ')
                                // } else {
                                handleClickOpen(item)
                                // }
                            }}
                        >
                            <Box className={styles.container}>
                                <img src={item['evaluation_image']} className={styles.img} />
                            </Box>

                            <Box sx={{ fontWeight: 600, color: '#478F96' }}>{item['evaluation_name']}</Box>
                            <Box
                                sx={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3, // Number of lines to show
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color: '#696984',
                                    fontSize: '14px',
                                }}
                            >{item['evaluation_detail']}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default Assessment

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}
